<template>
  <div style="padding:5vw" v-if="isShow" >
    <!-- <div style="padding:0vw">
      <van-cell-group style="margin-bottom: 10vw;">
        <van-field v-model="radio" label="UserId" placeholder="请输入UserId" type="textarea"/>
      </van-cell-group>
      <van-radio-group v-model="radio">
        <van-radio :name="item.UserId" v-for="(item,x) in list" :key="x" style="margin-bottom: 8vw;">{{ item.UserName }}</van-radio>
      </van-radio-group>
    </div> -->
    <van-button type="primary" color="#0063be" block style="margin: 0 0 5vw 0;" @click="login('/index')">进入首页</van-button>
    <van-button type="primary" color="#0063be" block style="margin: 0 0 5vw 0;" @click="login('/todo')">进入代办</van-button>
    <van-button type="primary" color="#0063be" block style="margin: 0 0 5vw 0;" @click="$router.push('/privacy')">隐私政策</van-button>
    <van-button type="primary" color="#0063be" block style="margin: 0 0 5vw 0;" @click="$router.push('/my')">我的</van-button>
    <van-button type="primary" color="#0063be" :loading="loading" block style="margin: 0 0 5vw 0;" @click="upFile(1,'下载的文件','pdf')">下载文件(type=1)</van-button>
    <van-button type="primary" color="#0063be" :loading="loading" block style="margin: 0 0 5vw 0;" @click="upFile(2,'下载的文件','xlsx')">下载文件(type=2)</van-button>
    <van-button type="primary" color="#0063be" :loading="loading" block style="margin: 0 0 5vw 0;" @click="upFile(3,'下载的文件','png')">下载文件(type=3)</van-button>
    <van-button type="primary" color="#0063be" :loading="loading" block style="margin: 0 0 5vw 0;" @click="getUserInfo">获取用户信息</van-button>

    <van-dialog v-model="show" width="90%" :show-confirm-button="false" :show-cancel-button="false">
      <div style="padding:10px">
      <pre>{{ result }}</pre>
      </div>
      <van-button type="primary" color="#0063be" block style="margin:5vw;width:80vw" @click="show=false">关闭</van-button>
    </van-dialog>
  </div>
</template>

<script>
import ApiUrls from "@/api/apiUrls";
export default {

  data() {
    return {
      isShow:false,
      show:false,
      result:{},
      radio:'',
      list:[{
        UserId:'ca2b8ce7-f2e9-4335-9785-530368ef12a3',UserName:'杨莉'      
      },{
        UserId:'79dd2616-4d08-449b-84eb-6a341b9da55f',UserName:'徐可'
      }],
      loading: false
    };
  },
  computed: {
  },
  beforeCreate() {
    if (this.$route.query.jmdl){
      this.$nextTick(()=>{        
        this.isShow=true
      })
    }else {
      this.$CheckStatus(this.$route.query,encodeURIComponent(window.location.href)).then(res => {
        this.radio=window.localStorage.getItem('UserId')
        this.isShow=true
      }).catch((error) => {
      })
    }

  },
  async created() {
    this.resultMsg=JSON.stringify(this.result, null, 2)
  },
  mounted() {
  },
  methods: {
    getUserInfo(){
      cs.getUserInfo((result) => {
        // alert(result)
        console.log(result,"获取最新的用户信息");
        this.show=true
        this.result=result
      });
    },
    login(path){
      this.$reqPost(ApiUrls.APPAPI_LOGIN, {
        "grant_type":"comwx_signin",
        "UserId":this.radio,
        "VerificationCode":"123456",
        "DeviceInfo":{
          "UserId":this.radio,
          "DeviceId":"S2K6K4K3J2H3G678N9J9J",
          "RegistrationId":"1507bfd3f6e17ae227c",
          "Manufacturer":"Apple",
          "DeviceModel":"iPhone15,2",
          "OS_Type":"iOS",
          "OS_Version":"iOS 17.2,",
          "App_Version":"1.0.3",
          "Bundle_ID":"com.example.app",
          "Remark":""}}).then(res => {
            if(!res.IsSuccess){
              this.$toast(res.Message)
              return
            }
          localStorage.setItem('token', res.Result.access_token)
          window.localStorage.setItem('UserName',res.Result.result.ADAccount)
          window.localStorage.setItem('UserId',res.Result.result.Id)
          if (path)this.$router.push(path)
      })
    },
    async upFile(i,filename,filetype){
      this.loading = true
      try {
        let res = await this.$reqPost(ApiUrls.APPAPI_GetFile+'?type='+i,{},{responseType: 'blob'})
        this.$downFile(res,filename,filetype)
      }catch (e) {

      }
      this.loading = false
    },
  },
};
</script>

<style scoped>
</style>
